var render, staticRenderFns
import script from "./chart_doughnut.vue?vue&type=script&lang=ts"
export * from "./chart_doughnut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports